import React, { useState } from 'react'

import { Option } from '@joor/design-system'
import { Dropdown } from '@joor/design-system'
import styled from 'styled-components'

import { useGetDropdownProps } from '../ImportOrders/SecondStep/SecondStep.hooks'
import StandardOrder from './StandardOrderTemplate/StandardOrderTemplate'

const Container = styled.div`
  max-height: calc(100vh - 380px);
  overflow: hidden;

  &.scroll {
    overflow: auto;
  }
`

const TemplateDropdownContainer = styled.div`
  padding: 16px 16px 0 16px;
  background-color: var(--color-secondary-100);
  display: grid;
  grid-template-columns: 4fr 2fr;
  grid-gap: 24px;

  & > div {
    text-align: left;
    & > label {
      width: 100%;
      margin: 0;
    }
  }
`

const OrderTemplateDropdown = styled(Dropdown)`
  margin-bottom: 14px;
`

enum OrderTemplate {
  STANDARD = 'JOOR Standard Excel Order',
}

const OrderTemplateOptions: Option[] = [
  {
    label: OrderTemplate.STANDARD,
    value: OrderTemplate.STANDARD,
  },
]

const Template: React.FC = () => {
  const [orderTemplate, setOrderTemplate] = useState<Option>(
    OrderTemplateOptions[0],
  )
  const [openedDropdown, setOpenedDropdown] = useState<string | null>(null)

  const getDropdownProps = useGetDropdownProps(
    openedDropdown,
    setOpenedDropdown,
  )

  const onSelectOrderTemplate: (args: {
    selected: Option
  }) => void | string = ({ selected }) => setOrderTemplate(selected)

  return (
    <Container className={openedDropdown ? '' : 'scroll'}>
      <TemplateDropdownContainer>
        <OrderTemplateDropdown
          key="orderTemplate"
          label="Select an order template"
          options={OrderTemplateOptions}
          value={orderTemplate}
          onSelect={onSelectOrderTemplate}
          isRequired
          data-testid="orderTemplate-dropdown"
        />
      </TemplateDropdownContainer>
      {orderTemplate === OrderTemplateOptions[0] && (
        <StandardOrder getDropdownProps={getDropdownProps} />
      )}
    </Container>
  )
}

export default Template
